import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import enTranslations from '@/i18n/en';

// Site is English-only; type kept permissive to avoid widespread refactors
// of legacy `language === 'fr'` checks (all evaluate to false at runtime).
export type Language = 'en' | 'fr';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const STORAGE_KEY = 'iso27001kit_language';

const detectInitialLanguage = (): Language => {
  return 'en';
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: 'en' as Language,
      setLanguage: () => {},
      t: (key: string) => enTranslations[key] || key,
    };
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const language: Language = 'en';
  const setLanguage = (_lang: Language) => {};
  const t = (key: string): string => enTranslations[key] || key;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
